<app-side-menu>
  <div class="service-order-config-container">
    <!-- Tabela de configurações de OS (dados fake utilizando componente reutilizável) -->
    <div class="config-table-wrapper">
      <app-table
        [title]="'Configurações de OS'"
        [data]="configOrders"
        [columns]="configOrderColumns"
        [loading]="loading"
        [showSearch]="true"
        [searchPlaceholder]="'Buscar configuração...'"
        [clickable]="true"
        [actions]="actions"
        [enableSorting]="true"
        (sortChange)="onSortChange($event)"
        (rowClick)="onRowClick($event)"
        (actionClick)="onActionClick($event)"
        [disablePagination]="true">
        
        <button
          table-header-action
          class="btn btn-primary new-service-order-btn"
          (click)="onAddNewConfig()">
          <i class="fas fa-plus me-2"></i>
          Nova Config. OS
        </button>
        
      </app-table>
    </div>
  </div>
</app-side-menu>
